import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ipm-search-mode-toggle',
  templateUrl: './search-mode-toggle.component.html',
  styleUrls: ['./search-mode-toggle.component.scss'],
})
export class SearchModeToggleComponent {
  @Input() mode: 'classic' | 'magic' = 'magic';
  @Output() modeChange = new EventEmitter<'classic' | 'magic'>();

  select(mode: 'classic' | 'magic'): void {
    if (mode === this.mode) return;
    this.modeChange.emit(mode);
  }
}
